<template>
  <b-modal id="modal-location-info" size="xl" ok-only ok-variant="dark">
    <template slot="modal-title">
      <div class="w-100">
        <router-link class="text-dark" :to="'/trip_guidebook/print/'+ data.slug" target="_blank">印刷用ページを開く</router-link>
      </div>
    </template>
    <location-info :data="data"></location-info>
  </b-modal>
</template>
<script>
import utils from "@/utils";
import LocationInfo from "@/components/LocationInfo";
export default {
  props: {
    data: Object
  },
  data() {
    return {};
  },
  components: {
    LocationInfo,
  },
  computed: {
    mapInfo() {
      if (!this.data.data.map_url) {
        return null;
      }

      const v = utils.convertMapUrlToLatLang(this.data.data.map_url);
      return v;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
